import type { FinancialMetricMode } from '../model/types'

import { FINANCIAL_METRIC_MODE_OPTIONS } from './getMetricModeTranslationKey'

const normalizeAvailableModes = (
  availableModes?: readonly FinancialMetricMode[]
): FinancialMetricMode[] => {
  if (!availableModes || availableModes.length === 0) {
    return [...FINANCIAL_METRIC_MODE_OPTIONS]
  }

  return FINANCIAL_METRIC_MODE_OPTIONS.filter((mode) => availableModes.includes(mode))
}

export const resolveFinancialMetricMode = (
  requestedMode?: FinancialMetricMode | null,
  availableModes?: readonly FinancialMetricMode[]
): FinancialMetricMode => {
  const normalizedAvailableModes = normalizeAvailableModes(availableModes)

  if (requestedMode && normalizedAvailableModes.includes(requestedMode)) {
    return requestedMode
  }

  return normalizedAvailableModes[0] ?? FINANCIAL_METRIC_MODE_OPTIONS[0]
}
